import { init } from 'astro/virtual-modules/prefetch.js';init()